import Image from '@components/Image';

import { WagtailImage } from '@/types';

type Props = {
  image: WagtailImage;
};

function BannerImage(props: Props) {
  const { image } = props;

  return (
    <div className='banner-image'>
      <Image image={image} priority fill style={{ objectFit: 'cover' }} />
    </div>
  );
}

export default BannerImage;
